import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExp } from 'src/app/core/config/regex';
import { Context } from 'src/app/shared/models/context';
import { Message } from 'src/app/shared/models/domain';
import { Account } from 'src/app/shared/models/finance';
import { CommonService } from 'src/app/shared/services/common.service';
import { FinanceService } from 'src/app/shared/services/finance.service';

@Component({
  selector: 'app-account-crud',
  templateUrl: './account-crud.component.html',
  styleUrls: ['./account-crud.component.scss'],
})
export class AccountCrudComponent implements OnInit {
  @Input() account: Account;
  @Input() context: Context;
  @Input() accounts: Account[] = [];
  public accountForm: FormGroup;
  public types: string[] = [];
  public natures: string[] = [];
  public categories: string[] = [];
  public submitted: boolean = false;
  private modified: boolean = false;

  constructor(
    private commonService: CommonService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private finaceService: FinanceService
  ) { }

  ngOnInit(): void {
    this.types = this.commonService.getTypes();
    this.finaceService.getAccounts(this.context.companyId).subscribe((accounts) => (this.accounts = accounts));
    this.finaceService.getNature().subscribe((natures) => {
      this.natures = natures.filter(nature => nature.toLowerCase() !== 'none');
    });
    this.setAccountForm(this.account)
    this.accountForm.get('parentId').valueChanges.subscribe((parentId) => {
      const natureControl = this.accountForm.get('nature');
      if (parentId) {
        natureControl.setValidators([Validators.required]);
        if (natureControl.value === 'none' || !natureControl.value) {
          natureControl.setValue(null); 
        }
      } else {
        natureControl.setValue('none');
        natureControl.clearValidators();
      }
      natureControl.updateValueAndValidity();
    });
  }

  public setAccountForm(account?: Account) {
    if (!account)
      account = {
        id: null,
        type: null,
        name: "",
        label: "",
        balance: null,
        mandatory: false,
        platform: false,
        category: null,
        nature: null,
        disabled: false,
        parentId: null,
        parentName: null,
        companyId: this.context?.companyId,
        companyName: null,
      } as Account;
    this.accountForm = this.fb.group({
      id: this.fb.control(account.id || null),
      name: this.fb.control(account.name, [Validators.required,Validators.pattern(RegExp.name)]),
      balance: this.fb.control(account.balance, [Validators.pattern(RegExp.number)]),
      mandatory: this.fb.control(account.mandatory, [Validators.required]),
      platform: this.fb.control(account.platform || this.context?.persona === 'ADMIN' ? true : false, []),
      type: this.fb.control(account?.type, [Validators.required,]),
      nature: this.fb.control(account?.nature || (account?.parentId ? null : 'none'), []),      
      category: this.fb.control(account?.category, []),
      parentId: this.fb.control(account?.parentId, []),
      parentName: this.fb.control(account?.parentName, []),
      companyId: this.fb.control(account?.companyId, [Validators.required,]),
      companyName: this.fb.control(account?.companyName, []),
      label: this.fb.control(account.label, [Validators.pattern(RegExp.label)]),
      disabled: this.fb.control(account.disabled, []),
    });
    this.accountForm.valueChanges.subscribe(value => this.modified = true);
  }

  get f() {
    return this.accountForm.controls;
  }

  public saveAccount(inProgress?: any) {
    this.submitted = true;
    if (this.accountForm.valid) {
      const account: Account = this.accountForm.value;
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Account ${account.name} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (account.id) {
        this.finaceService.updateAccount(account.id, account).subscribe({
          next: (response: Message) => {
            if (response) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Account has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, response.text);
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.finaceService.createAccount(account).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, response.text);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, response.text);
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }
}
